import React from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { safeHTML } from '../../../utils/safeHTML';
import { useModal } from '../../../hooks/useModal';
import useStateControls from '../../../hooks/useStateControls';
import { useOpen } from '../../../hooks/useOpen';
import Icon from '../../baseComponents/gui/icon/Icon';
import { useTranslation } from '../../../translations';

const TempPromoModal = React.forwardRef(function TempPromoModal(
  {
    id: modalId,
    image,
    title,
    subtitle,
    description,
    buttons,
    redirect,
    closeCallback,
    onClose,
    callbacks = {},
    energy,
  },
  ref,
) {
  const { id, closeModal } = useModal();
  const { setState } = useStateControls();
  const openLink = useOpen();
  const { t } = useTranslation();
  // const [copied, setCopied] = useState(false);

  // Промокод, если есть
  // const promo = prize && prize.promocode ? prize.promocode : null;

  /* const handleCopy = () => {
        if (promo) {
            navigator.clipboard.writeText(promo).then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            });
        }
    }; */
  // Кнопки
  const buttonCallbacks = {
    close() {
      closeModal({ id });
      onClose?.();
      closeCallback?.();
    },
    redirect() {
      setState(redirect);
      closeModal({ id });
      closeCallback?.();
    },
    toShop({ link }) {
      if (link === 'closeModal') {
        closeModal({ id });
        closeCallback?.();
      } else {
        openLink(t(link, { defaultValue: link }));
        typeof modalId === 'number' && callbacks.openCustomModal(modalId);
      }
    },
    /* copyPromocode() {
          copy();
          GTMQuizCopyPromo(id);
        } */
  };

  return (
    <CustomModal>
      <div className={classNames(`temp-promo-modal`)} ref={ref}>
        <div className={classNames('temp-promo-modal__content')}>
          <div className='temp-promo-modal__image'>
            {energy >= 0 && (
              <p className='temp-promo-modal__energy'>
                <Icon name='sunRabbit/lightning' />
                {energy}
              </p>
            )}
            {image && <img src={image} alt={title || ''} />}
          </div>
          <div className='temp-promo-modal__text-container'>
            {subtitle && <p className='temp-promo-modal__subtitle'>{safeHTML(t(subtitle))}</p>}
            {title && <h2 className='temp-promo-modal__title'>{safeHTML(t(title))}</h2>}
            {/*  {promo && (
                            <div className="temp-promo-modal__promocode">
                                <div className="temp-promo-modal__promocode-text">{promo}</div>
                                <CustomButton
                                    className="temp-promo-modal__promocode-btn"
                                    onClick={buttonCallbacks.copyPromocode}
                                >
                                    {copied ? "Скопировано!" : "Скопировать промокод"}
                                </CustomButton>
                            </div>
                        )} */}
            {description && <div className='temp-promo-modal__text'>{safeHTML(t(description))}</div>}
            <div className='temp-promo-modal__buttons'>
              {buttons.map((button, index) => (
                <CustomButton key={index} {...button.attr} onClick={() => buttonCallbacks[button.action]?.(button)} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </CustomModal>
  );
});

export default TempPromoModal;
TempPromoModal.propTypes = {};
TempPromoModal.displayName = 'TempPromoModal';
